import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { StatusClusteringDisplay } from '@/components/StatusClusteringDisplay';
import { ArchivVorgangTable } from '@/pages/Vorgaenge/ArchivVorgangTable';
import type { VorgangBearbeitungLocationState } from '@/pages/VorgangBearbeitung';
import { VorgangListeItem } from '@/types';

export const ArchivPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleEdit = (item: VorgangListeItem) => {
    navigate(`/vorgaenge/${item.id}`, {
      state: {
        from: location.pathname,
      } satisfies VorgangBearbeitungLocationState,
    });
  };

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between pt-3">
        <h1 className="text-2xl font-bold text-text-primary">Archiv</h1>

        <div className="flex items-center gap-4">
          <StatusClusteringDisplay scope="archive" showGesamtBadge />
        </div>
      </div>
      <ArchivVorgangTable onEdit={handleEdit} />
    </div>
  );
};
